import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { OperatorType } from '@shared/constants/operatorsList';

export interface LoanRestriction {
  id: string;
  state: string | null;
  loanAmount: number | null;
  loanAmountOperator: OperatorType | null;
  apr: number | null;
  aprOperator: OperatorType | null;
  rate: number | null;
  rateOperator: OperatorType | null;
  isActive: boolean;
}

export interface IStateProductRestriction {
  id?: string;
  state: string;
  productType: string;
  maxAllowedAmount: number;
  maxAllowedFormula: string;
  isAllowed: boolean;
  isNew?: boolean;
  calculationType: string | number;
}

export interface IStateProductRestrictionPayload {
  id?: string;
  name?: string;
  state: string;
  maxAllowedAmount: number;
  maxAllowedFormula: string;
  calculationType?: string | number;
  isAllowed?: boolean;
}

export interface IFormulaFormValues {
  id?: string;
  state: string;
  maxAllowedAmount: number;
  maxAllowedFormula: string;
  calculationType: string | number;
}

export interface IFormulaProps {
  modalData: IStateProductRestriction | null,
  handleClose(): void;
  productId?: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  lenderId?: string;
  lenderProductRulesMutate?: () => void;
  stateProductRestrictionsMutate?: () => void;
  apiRef: React.MutableRefObject<GridApiPro>;
}

export interface IFormulaFormProps {
  handleClose: () => void;
  loading: boolean;
}

export interface IFormulaVariables {
  lenderVariable: string;
  id: string;
}

export const stateProductRestrictionFormulaVariables = [
  {
    lenderVariable: 'Principle or Sales Price',
    id: 'SLPR',
  },
  {
    lenderVariable: 'Amount Financed or Total Amount Financed or Disclosed Amt Financed',
    id: 'AMTFIN',
  },
  {
    lenderVariable: 'Same as name',
    id: 'RATE',
  },
  {
    lenderVariable: 'Same as name',
    id: 'TERM',
  },
  {
    lenderVariable: 'Title Fee',
    id: 'TITLE',
  },
  {
    lenderVariable: 'Hello Refi Cost',
    id: 'ILDC',
  },
  {
    lenderVariable: 'The Front End amount(based on the Lender Utility Formula)',
    id: 'FE',
  },
  {
    lenderVariable: 'Default Doc Fee or Total Doc Fees',
    id: 'DOCF',
  },
  {
    lenderVariable: 'Cash Down',
    id: 'CDWN',
  },
  {
    lenderVariable: 'JD Power Retail',
    id: 'JDRET',
  },
  {
    lenderVariable: 'JD Power Trade',
    id: 'JDTRA',
  },
  {
    lenderVariable: 'KBB Retail',
    id: 'KBBRET',
  },
  {
    lenderVariable: 'KBB Trade',
    id: 'KBBTRA',
  },
];

export const stateProductRestrictionFormulaExamples = [
  {
    description: 'GAP amount can not exceed 4% of the Amount Financed or $600, whichever is greater.',
    formula: 'max((AMTFIN * 0.04), 600)'
  },
  {
    description: 'GAP amount can not exceed 4% of the Sales Price minus the Cash Down or $600, whichever is greater.',
    formula: 'max(((SLPR-CDWN)* 0.04), 600)'
  },
  {
    description: 'GAP can not exceed the iLending Cost times two.',
    formula: 'ILDC * 2'
  },
];

